class SaleCountdown extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    if (Number.isNaN(this.end)) return;

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = this.end - Date.now();

    if (remaining <= 0) {
      this.textContent = this.dataset.ended || '';
      const bar = this.closest('.announcement-bar');
      if (bar) bar.hidden = true;
      clearInterval(this.timer);
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value) => String(value).padStart(2, '0');

    this.textContent = `${pad(days)}${this.dataset.days || 'd'} ${pad(hours)}${this.dataset.hours || 'h'} ${pad(minutes)}${this.dataset.minutes || 'm'} ${pad(seconds)}${this.dataset.seconds || 's'}`;
  }
}

if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', SaleCountdown);
}
